<template>
  <v-app id="app" :style="{ backgroundColor: theme.background }">
    <landscape-warning />
    <error />
    <success />
    <Loader />
    <re-login />
    <DDos />
    <chat />
    <router-view />
  </v-app>
</template>

<script lang="ts" setup>
import DDos from '@/components/DDos.vue';
import Error from '@/components/Error.vue';
import Loader from '@/components/Loader.vue';
import ReLogin from '@/components/ReLogin.vue';
import Success from '@/components/Success/index.vue';
import Chat from '@/widgets/chat/ui/Chat.vue';
import '@ifr/form-questionnaire/dist/form-questionnaire.css';
import { computed } from 'vue';
import store from '@/store';
import LandscapeWarning from '@/components/layout/LandscapeWarning.vue';

const theme = computed(() => store.getters.theme);

const colorPrimary = computed(() => theme.value.primary);
const colorError = computed(() => theme.value.error);
const colorRequired = computed(() => theme.value.requiredColor);
const colorSuccess = computed(() => theme.value.success);
const colorStepperCard = computed(() => theme.value.fieldStepperColor);

const verticalIndentation = computed(() => {
  return `${store.getters.verticalIndentation}px`;
});

const horizontalIndentation = computed(() => {
  return `${store.getters.horizontalIndentation}px`;
});
</script>

<style lang="scss">
@use './assets/style/app.scss';

#app {
  --color-gray-100: #f3f4f6;
  --color-gray-200: #dde2e4;
  --color-gray-300: #d4dbde;
  --color-gray-400: #acbac2;
  --color-gray-500: #9aa6bb;
  --color-gray-600: #677a84;
  --color-gray-700: #3b515e;
  --color-gray-800: #3b515e;
  --color-gray-900: #263b46;

  --color-white: #ffffff;

  --color-primary: v-bind(colorPrimary);
  --color-error: v-bind(colorError);
  --color-required: v-bind(colorRequired);
  --color-success: v-bind(colorSuccess);
  --color-stepper-card: v-bind(colorStepperCard);

  // G - global
  --g-card-padding: 15px; // Паддинг внутри подложек
  --g-margin-vertical: v-bind(verticalIndentation);
  --g-margin-horizontal: v-bind(horizontalIndentation);
}

.gray-100 {
  color: var(--color-gray-800) !important;
  background-color: var(--color-gray-100) !important;
}
</style>
